import * as React from "react";
const SVGComponent = (props) => (
  <svg
    viewBox="0 0 92 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g filter="url(#filter0_dddddd_718_1338)">
      <path
        d="M16.9895 13.4317L14.5886 12.9541L14.8571 10.6572L10.0238 9.69582L7.87215 11.6181L5.59673 11.1655L15.6263 2.33689L18.1057 2.83008L16.9895 13.4317ZM15.5374 4.77771L11.8195 8.0893L15.0836 8.73856L15.5374 4.77771ZM24.3059 9.15047L29.6871 5.13376L31.9311 5.58012L20.4892 14.1278L18.2452 13.6814L21.8484 10.9964L21.6211 3.52933L24.1633 4.03501L24.3059 9.15047ZM36.7737 6.38874C38.4057 6.71337 39.5002 7.46711 40.0572 8.64995C40.6141 9.83278 40.4892 11.1274 39.6825 12.5338C38.8757 13.9401 37.6419 15.0142 35.981 15.7558C34.3201 16.4975 32.6736 16.706 31.0416 16.3814C29.8385 16.1421 28.9358 15.6636 28.3334 14.9459C27.7469 14.221 27.4778 13.4202 27.5262 12.5433L30.0194 12.2507C30.0048 12.8044 30.1714 13.2962 30.5191 13.7262C30.8827 14.149 31.4045 14.428 32.0845 14.5633C32.89 14.7235 33.7183 14.6512 34.5692 14.3463C35.4201 14.0414 36.1466 13.5674 36.7486 12.9243L31.9623 11.9723L32.9655 10.2235L37.7517 11.1756C37.9352 10.4493 37.8457 9.81298 37.483 9.26667C37.1204 8.72036 36.5363 8.36708 35.7308 8.20685C35.0507 8.07159 34.3459 8.11177 33.6161 8.3274C32.9021 8.53585 32.2658 8.86284 31.7072 9.30837L30.0261 8.1854C30.8905 7.47085 31.9265 6.93473 33.1341 6.57705C34.3574 6.2122 35.5706 6.14943 36.7737 6.38874ZM47.4043 14.0697C47.8472 14.3949 48.1114 14.7876 48.1971 15.2479C48.288 15.699 48.1928 16.1697 47.9115 16.66C47.4179 17.5205 46.6225 18.1148 45.5252 18.4429C44.4383 18.773 43.3038 18.8205 42.1216 18.5854C41.2324 18.4085 40.4619 18.1058 39.8103 17.6772C39.1587 17.2486 38.7225 16.7289 38.5018 16.1181L40.632 14.9647C40.8486 15.4201 41.1915 15.8078 41.6606 16.1279C42.1401 16.4501 42.6415 16.6632 43.1645 16.7673C43.6981 16.8734 44.209 16.8565 44.6972 16.7165C45.1908 16.5673 45.5357 16.3215 45.7321 15.9791C46.1673 15.2204 45.6212 14.6892 44.0938 14.3854L42.6815 14.1044L43.6846 12.3557L45.0969 12.6366C46.6243 12.9405 47.6056 12.713 48.0409 11.9543C48.2372 11.612 48.2134 11.298 47.9693 11.0123C47.7305 10.7175 47.3444 10.5169 46.8108 10.4108C46.2877 10.3068 45.6696 10.2972 44.9566 10.3821C44.2539 10.4692 43.582 10.6551 42.9408 10.9398L42.4347 9.26202C43.2392 8.8551 44.1212 8.5976 45.0807 8.48951C46.0401 8.38142 46.9645 8.41582 47.8537 8.5927C49.0359 8.82785 49.8891 9.27073 50.4134 9.92135C50.9481 10.574 50.9686 11.3306 50.475 12.1911C50.1938 12.6815 49.7821 13.0944 49.24 13.4298C48.7032 13.756 48.0913 13.9693 47.4043 14.0697ZM50.0094 18.5463C49.4524 17.3634 49.5773 16.0688 50.3841 14.6624C51.1908 13.2561 52.4247 12.182 54.0856 11.4404C55.7465 10.6987 57.393 10.4902 59.025 10.8148C60.657 11.1394 61.7515 11.8932 62.3085 13.076C62.8654 14.2588 62.7405 15.5535 61.9338 16.9598C61.1271 18.3662 59.8932 19.4402 58.2323 20.1819C56.5714 20.9236 54.9249 21.1321 53.2929 20.8075C51.6609 20.4828 50.5664 19.7291 50.0094 18.5463ZM54.9929 13.0588C53.9835 13.5384 53.2214 14.2269 52.7066 15.1244C52.1918 16.0219 52.0887 16.8415 52.3975 17.5833C52.7168 18.3271 53.3629 18.7958 54.3358 18.9894C55.3192 19.185 56.3156 19.043 57.325 18.5634C58.3344 18.0839 59.0965 17.3953 59.6113 16.4979C60.1261 15.6004 60.2292 14.7807 59.9204 14.039C59.6116 13.2972 58.9655 12.8285 57.9821 12.6329C57.0091 12.4394 56.0127 12.5814 54.9929 13.0588ZM70.2943 18.4991C70.6953 18.816 70.9177 19.2107 70.9613 19.6832C71.0207 20.1486 70.9018 20.6404 70.6046 21.1585C70.164 21.9265 69.4971 22.4999 68.6037 22.8788C67.7156 23.2485 66.7746 23.3345 65.7808 23.1368L60.5238 22.0912L66.0967 12.3761L70.8829 13.3281C71.8768 13.5258 72.5338 13.9348 72.8539 14.5551C73.1741 15.1755 73.1113 15.8742 72.6655 16.6514C72.1506 17.5489 71.3603 18.1648 70.2943 18.4991ZM69.684 14.9915L67.2987 14.517L65.9612 16.8486L68.3465 17.3231C68.7859 17.4105 69.2 17.3692 69.5889 17.1992C69.9883 17.0312 70.2862 16.7761 70.4826 16.4337C70.679 16.0914 70.7022 15.7867 70.5523 15.5198C70.4128 15.255 70.1234 15.0789 69.684 14.9915ZM63.6843 20.818L66.3677 21.3517C66.8071 21.4391 67.2186 21.4024 67.6022 21.2416C67.9911 21.0716 68.2838 20.8154 68.4802 20.4731C68.6765 20.1307 68.705 19.8272 68.5655 19.5623C68.4314 19.2882 68.1446 19.1075 67.7052 19.0201L65.0218 18.4863L63.6843 20.818ZM80.8938 26.143L78.4929 25.6654L78.7614 23.3686L73.9281 22.4072L71.7764 24.3294L69.501 23.8768L79.5306 15.0482L82.01 15.5414L80.8938 26.143ZM79.4417 17.4891L75.7238 20.8007L78.9879 21.4499L79.4417 17.4891Z"
        fill="white"
      />
    </g>
    <defs>
      <filter
        id="filter0_dddddd_718_1338"
        x={0.51709}
        y={0.311523}
        width={91.0293}
        height={48.9702}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_718_1338"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.98 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_718_1338"
          result="effect2_dropShadow_718_1338"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={3} />
        <feGaussianBlur stdDeviation={1.5} />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.85 0"
        />
        <feBlend
          mode="normal"
          in2="effect2_dropShadow_718_1338"
          result="effect3_dropShadow_718_1338"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={7} />
        <feGaussianBlur stdDeviation={2} />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
        />
        <feBlend
          mode="normal"
          in2="effect3_dropShadow_718_1338"
          result="effect4_dropShadow_718_1338"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={12} />
        <feGaussianBlur stdDeviation={2.5} />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
        />
        <feBlend
          mode="normal"
          in2="effect4_dropShadow_718_1338"
          result="effect5_dropShadow_718_1338"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={18} />
        <feGaussianBlur stdDeviation={2.5} />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0"
        />
        <feBlend
          mode="normal"
          in2="effect5_dropShadow_718_1338"
          result="effect6_dropShadow_718_1338"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect6_dropShadow_718_1338"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);
export default SVGComponent;
